import React, { useState } from "react";
import { Tabs } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { useWizardState } from "../hooks/useWizardState";
import Credit from "../pages/DashboardTabs/Credit";
import GoogleAssets from "../pages/DashboardTabs/GoogleAssets";
import GoogleSettings from "../pages/DashboardTabs/GoogleSettings";
import History from "../pages/DashboardTabs/History";
import MetaAssets from "../pages/DashboardTabs/MetaAssets";
import MetaSettings from "../pages/DashboardTabs/MetaSettings";
import Statistics from "../pages/DashboardTabs/Statistics";

interface DashboardTabsProps {
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
}

const DashboardTabs = ({ activeTab: externalActiveTab, onTabChange: externalOnTabChange }: DashboardTabsProps) => {
  const [internalActiveTab, setInternalActiveTab] = useState("dashboard");
  const activeTab = externalActiveTab ?? internalActiveTab;
  const setActiveTab = externalOnTabChange ?? setInternalActiveTab;
  const { t } = useTranslation("translation", { keyPrefix: "Components.DashboardTabs" });
  const { googleWizardFinished, metaWizardFinished } = useWizardState();

  const tabs = [
    {
      content: <Statistics />,
      id: "dashboard",
      title: t("dashboard"),
    },
  ];

  if (googleWizardFinished) {
    tabs.push(
      {
        content: <GoogleSettings />,
        id: "settings-google",
        title: t("settings google"),
      },
      {
        content: <GoogleAssets />,
        id: "assets-google",
        title: t("assets google"),
      }
    );
  }

  if (metaWizardFinished) {
    tabs.push(
      {
        content: <MetaSettings />,
        id: "settings-meta",
        title: t("settings meta"),
      },
      {
        content: <MetaAssets />,
        id: "assets-meta",
        title: t("assets meta"),
      }
    );
  }

  tabs.push(
    {
      content: <History />,
      id: "history",
      title: t("history"),
    },
    {
      content: <Credit />,
      id: "credit",
      title: t("credit"),
    }
  );

  return <Tabs activeTabId={activeTab} tabs={tabs} onTabChange={setActiveTab} />;
};

export default DashboardTabs;
